
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3010_41696)","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M13.547 12.607a2.023 2.023 0 01-1.611 0L2.164 8.081a.96.96 0 010-1.714l9.772-4.56a2.023 2.023 0 011.611 0l9.772 4.526a.96.96 0 010 1.714l-9.772 4.56z","stroke":"#fff"}}),_c('path',{attrs:{"d":"M23.887 13.378L13.43 18.195a1.714 1.714 0 01-1.423 0L1.602 13.378","stroke":"#EDC843"}}),_c('path',{attrs:{"d":"M23.887 18.95L13.43 23.767a1.714 1.714 0 01-1.423 0L1.602 18.95","stroke":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3010_41696"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.75 .778)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    